import React, { useEffect } from 'react';
import ApplicationCooLayout from '../layout/application-coo-layout';

// Declare global Search.gov.sg types
declare global {
  interface Window {
    searchgov?: {
      init: () => void;
    };
  }
}

function SearchSG() {
    useEffect(() => {
        const script = document.createElement("script");
        script.id = "searchsg-config";
        script.src =
          "https://api.search.gov.sg/v1/searchconfig.js?clientId=955732ef-0fee-44b9-adb4-b5d9e848eef1&page=result";
        script.defer = true;
        document.body.appendChild(script);
        return () => {
          document.getElementById("searchsg-config")?.remove();
        };
        
      }, []);

  return (
    <div className="polymer-application-coo_searchsg" style={{marginTop:"1px"}}>
      <div id="searchsg-result-container" style={{ minHeight: "100vh" }} />
    </div>
  )
}

export default SearchSG
